import React, { useState, useEffect } from 'react'
import './MenuMain.scss'
import SocialNetworks from './SocialNetworks'

const MenuMain = ({ isMenuOpen = false, pagePoint = '' }) => {
  const [menuOpen, setMenuOpen] = useState(false)
  const menuItems = [
    { name: 'services', url: '/services' },
    { name: 'what we do', url: '/about-us' },
    { name: 'industries', url: '/industries' },
    { name: 'case studies', url: '/case-studies' },
    { name: 'careers', url: '/careers' },
    { name: 'contact us', url: '/contact' }
  ]

  useEffect(() => {
    setMenuOpen(isMenuOpen)
  }, [isMenuOpen])

  return (
    <nav className="nav">
      <ul className={`nav-list ${menuOpen ? 'open' : ''}`}>
        {menuItems.map((item, idx) => (
          <li key={idx} style={{ animationDelay: 2 * (idx + 1) * 80 + 'ms' }}>
            <a href={item.url} className={item.url == pagePoint ? 'point' : ''}>{item.name}</a>
          </li>
        ))}
        <li className='menu-social-networks'>
          <span>Follow us</span>
          <SocialNetworks />
        </li>
      </ul>
    </nav>
  )
}

export default MenuMain